if (!customElements.get('purefect-product-reward')) {
  customElements.define('purefect-product-reward', class extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById(this.dataset.formId);
      this.onChange = (event) => {
        if (event.target.form === this.form) this.update();
      };
      document.addEventListener('change', this.onChange);
      this.update();
    }

    disconnectedCallback() {
      document.removeEventListener('change', this.onChange);
    }

    update() {
      const variantId = this.form?.querySelector('[name="id"]')?.value;
      const option = Array.from(this.querySelectorAll('[data-reward-variant]'))
        .find(item => item.dataset.rewardVariant === variantId);
      // Subscription controls can sit outside the form with a form attribute.
      const subscription = this.form?.elements.namedItem('selling_plan')?.value;
      this.hidden = !option || Boolean(subscription);
      if (option) {
        this.querySelector('[data-reward-cost]').textContent =
          Number(option.dataset.rewardPoints).toLocaleString('en-US');
      }
    }
  });
}
